import { SET_USER } from '../types'
import { saveStateToLocalStorage } from '../utilsLocalStorage'

export const setSelectedUserSetup = setup => ({
  type: SET_USER.SETUP,
  payload: setup,
})

export const userSetups = (allSetups, powerSetups, permissions) => {
  const key = permissions.includes('settings') ? 'name' : 'alias'
  const transformedSetups = allSetups.map(el => el[key])
  const transformedPowerSetups = powerSetups.map(el => el[key])

  // Store only alias→name mapping (minimal footprint)
  const aliasToNameMapping = allSetups.reduce((acc, setup) => {
    acc[setup.alias] = setup.name
    return acc
  }, {})

  return dispatch => {
    dispatch({
      type: SET_USER.SETUPS,
      payload: transformedSetups,
    })
    dispatch({
      type: SET_USER.POWER_SETUPS,
      payload: transformedPowerSetups,
    })
    saveStateToLocalStorage(aliasToNameMapping, 'setupsMapping')
  }
}
